import {
  defaultHeaderComponents,
  HeaderRendererProps,
} from "@sinecycle/growcomponents";
import { Row } from "antd";

function CFHeader<T>(props: HeaderRendererProps<T>) {
  return (
    <Row wrap={false}>
      {defaultHeaderComponents.defaultHeader({
        ...props,
        headerStyles: { cursor: "auto" },
      })}
    </Row>
  );
}

export { CFHeader };
